import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { Store } from "../Store";
import useAxios from "../hooks/useAxios";
import { getError, turkishCurrencyFormatterNoPrecision } from "../utils";
import AskQuestionModal from "./AskQuestionModal";
import MenuIconForTouch from "./MenuIconForTouch";
import NumberPad from "./NumberPad";
import SepetItemCreator from "./SepetItemCreator";
import TouchBackgroundImageForButton from "./TouchBackgroundImageForButton";

export default function ProductsListTouch(props) {
  const axios = useAxios();
  const [numberPadNumber, setNumberPadNumber] = useState(null);
  const [productQuantity, setProductQuantity] = useState(1);
  const [itemCreateLoading, setItemCreateLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState({ _id: "" });

  const { state } = useContext(Store);
  const { userInfo, carts } = state;

  const [showQuestions, setShowQuestions] = useState(false);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (selectedProduct.questions) {
      setQuestions(
        selectedProduct.questions.map((q) => ({
          ...q,
          answers: [...q.answers.map((a) => ({ ...a, selected: false }))],
        }))
      );
    } else {
      setQuestions([]);
    }
  }, [selectedProduct]);

  const {
    products,
    tableNum,
    features,
    feature,
    product,
    setFeature,
    setFeatures,
    setProduct,
    setIsVisible,
    isVisible,
    setQueryByName,
    setNumberPadNumberSelectionHandler,
    isCustomerOrder,
    showAddCard,
    setShowAddCard,
    showNumberPad,
    setShowNumberPad,
  } = props;

  const { dispatch: ctxDispatch } = useContext(Store);

  const updateCartHandler = async (quantity) => {
    try {
      const itemCode = uuidv4();

      const { data } = carts[tableNum - 1].tableCode
        ? { data: carts[tableNum - 1] }
        : await axios.get(`/api/customer?tableNum=${tableNum}`);

      const orderCode = data.orderCode || uuidv4();

      const cartItems = [
        {
          ...product,
          quantity,
          createdAt: new Date().toISOString(),
          feature:
            product.features.length === 1 ? product.features[0] : feature,
          tableNum: tableNum,
          itemCode: itemCode,
          tableCode: data.tableCode,
          orderCode,
          delivered: false,
          alert: false,
          questions: questions || [],
          answers:
            questions
              ?.filter((q) => q.answers.filter((a) => a.selected).length > 0)
              .map((q) => ({
                question: q.question,
                questionId: q._id,
                answers: q.answers
                  .filter((a) => a.selected)
                  .map((a) => ({
                    answer: a.answer,
                    answerId: a._id,
                    cost: a.cost,
                    image: a.image,
                    product: a.product,
                    feature: a.feature,
                    firstCost: a.firstCost,
                  })),
              })) || [],
        },
      ];

      if (tableNum > 300) {
        await axios.put(
          `/api/customer/homeorder/${carts[tableNum - 1].clientCode}`,
          {
            cartItems,
            customerName: carts[tableNum - 1].description,
            address: carts[tableNum - 1].cartItems[0].address,
          }
        );
      } else {
        await axios.put(`/api/customer/${data.tableCode}`, {
          cartItems,
          customerName: carts[tableNum - 1].description,
          clientCode: userInfo.clientCode,
          orderCode,
          businessOwner:
            userInfo.isHelpDesk && userInfo.client
              ? userInfo.client.businessOwner
              : userInfo.membership.businessOwner,
        });
      }

      ctxDispatch({
        type: "CART_ADD_ITEM",
        payload: cartItems[0],
      });

      toast.success(
        quantity +
          " adet " +
          (feature ? feature.name + " " : "") +
          product.name +
          " sepete eklendi"
      );
    } catch (err) {
      toast.error(getError(err));
    }
  };

  const sepeteEkleHandler = async () => {
    if (!tableNum) {
      if (isCustomerOrder) {
        toast.error("Lütfen öncelikle bir sipariş seçiniz.");
      } else {
        toast.error("Lütfen böncelikle bir masa seçiniz.");
      }
      return;
    }

    if (features.length > 0 && !feature) {
      toast.error("Lütfen ürün çeşidi seçiniz!");
      return;
    }
    setItemCreateLoading(true);
    await updateCartHandler(productQuantity);
    if (setQueryByName) {
      setQueryByName("");
    }
    if (navigate) {
      navigate(`/order/touch?rootCategory=`);
    }
    setFeature("");
    setProduct("");
    setFeatures([]);
    setProductQuantity(1);
    setShowAddCard(false);
    setItemCreateLoading(false);
    setShowQuestions(false);
  };

  const sepeteEkleVazgecHandler = () => {
    if (feature) {
      setFeature("");
      setProduct("");
      setFeatures([]);
      if (setQueryByName) {
        setQueryByName("");
      }
      setProductQuantity(1);
    } else {
      if (product) {
        setProduct("");
        if (setQueryByName) {
          setQueryByName("");
        }
      }
    }
    setProductQuantity(1);
    setShowAddCard(false);
  };

  const decrementProductItemHandler = (quantity) => {
    if (
      (product.isHalfPortion && productQuantity > 0.5) ||
      (!product.isHalfPortion && productQuantity > 1)
    ) {
      if (productQuantity - (quantity ? quantity : 1) > 0) {
        setProductQuantity(productQuantity - (quantity ? quantity : 1));
      }
    }
  };
  const incrementProductItemHandler = (quantity) => {
    if (
      product.questions?.length > 0 &&
      productQuantity + (quantity || 1) > 1
    ) {
      toast.info(
        "Bu ürün menü olarak tanımlanmış, menü ürünleri sepete bir adet veya yarım porsiyon olarak eklenmelidir!",
        { autoClose: 10000 }
      );
      return;
    }
    setProductQuantity(productQuantity + (quantity ? quantity : 1));
  };

  const getProductNameLength = (product) => {
    if (product.features && product.features.length === 1) {
      return (product.features[0].name + " " + product.name).length;
    } else {
      return product.name.length;
    }
  };

  const isProductPrimary = (product, selectedProduct) => {
    if (product.features && product.features.length === 1) {
      if (selectedProduct.features && selectedProduct.features.length === 1) {
        if (
          product._id === selectedProduct._id &&
          product.features[0]._id === selectedProduct.features[0]._id
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (product._id === selectedProduct._id) {
      return true;
    }
  };

  return (
    <div
      className="bg-secondary border border-secondary rounded p-1  heightOfPanelTouch touchPanelCompartment"
      style={{
        overflow: "visible",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "stretch",
          margin: "0.3rem",
        }}
      >
        <Button
          style={{ width: "100%" }}
          className="p-2 px-3"
          variant="outline-light"
          size="sm"
          onClick={(e) => {
            setNumberPadNumber(null);
            setShowNumberPad(true);
          }}
        >
          <div className="small-font  text-bold">123...</div>
          <i className="fas fa-hand-pointer-o " />
        </Button>

        <Button
          style={{ width: "100%" }}
          variant="outline-light"
          className="p-2 px-3 ms-2"
          size="sm"
          onClick={(e) => {
            setIsVisible(!isVisible);
          }}
        >
          <div className="small-font  text-bold">abc...</div>
          <i className="fas fa-keyboard-o" />
        </Button>
      </div>

      <div style={{ overflow: "auto" }} className="scrollbar scrollbar-primary">
        {(!products || products.length === 0) && (
          <Button
            style={{
              width: "300px",
              aspectRatio: "4/1",
              margin: "0.6rem",
            }}
          >
            <span className="text-bold">Ürün bulunamadı!</span>
          </Button>
        )}

        {[...Array(products.length).keys()].map((k) => {
          return (
            <div
              key={k}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              {products
                .filter((p, i) => i >= k * 2 && i < (k + 1) * 2)
                .map((p) => (
                  <Button
                    onClick={() => {
                      setFeatures(p.features);
                      setFeature("");
                      setProduct(p);
                      setSelectedProduct(p);
                      if (p.features && p.features.length === 1) {
                        setFeature(p.features[0]);
                      }
                      setShowAddCard(true);
                    }}
                    key={
                      p._id +
                      "" +
                      (p.features && p.features.length > 0
                        ? p.features[0]._id
                        : "")
                    }
                    variant={
                      isProductPrimary(p, selectedProduct) ? "primary" : "light"
                    }
                    style={{
                      width: "150px",
                      aspectRatio: "2/1",
                      margin: "0.3rem",
                      position: "relative",
                    }}
                  >
                    {p.questions?.length > 0 && <MenuIconForTouch />}
                    <TouchBackgroundImageForButton product={p} />
                    <div>
                      {getProductNameLength(p) > 18 ? (
                        <>
                          {p.features && p.features.length === 1 && (
                            <span className="small-font text-bold text-danger">
                              {p.features[0].name + " "}
                            </span>
                          )}
                          <span className="text-bold small-font">{p.name}</span>
                          {p.no && (
                            <span className="small-font">
                              &nbsp; {"No " + p.no}
                            </span>
                          )}
                        </>
                      ) : (
                        <>
                          {p.features && p.features.length === 1 && (
                            <span className="text-bold text-danger">
                              {p.features[0].name + " "}
                            </span>
                          )}
                          <span className="text-bold">{p.name}</span>
                          {p.no && (
                            <span className="small-font">
                              &nbsp;{"No " + p.no}
                            </span>
                          )}
                        </>
                      )}
                      &nbsp;
                      <span className="text-info text-bold small-font">
                        {turkishCurrencyFormatterNoPrecision(
                          p.price > 0
                            ? p.price.toFixed(2)
                            : p.features.length > 0
                            ? p.features[0].price.toFixed(2)
                            : 0
                        )}
                      </span>
                    </div>
                  </Button>
                ))}

              {products.length === 1 && (
                <Button
                  onClick={() => {}}
                  style={{
                    width: "150px",
                    aspectRatio: "2/1",
                    margin: "0.3rem",
                    visibility: "hidden",
                  }}
                ></Button>
              )}
            </div>
          );
        })}

        <SepetItemCreator
          showAddCard={showAddCard}
          setShowAddCard={setShowAddCard}
          features={features}
          setFeature={setFeature}
          feature={feature}
          decrementProductItemHandler={decrementProductItemHandler}
          incrementProductItemHandler={incrementProductItemHandler}
          product={product}
          sepeteEkleHandler={() => {
            if (product.questions?.length > 0) {
              setShowQuestions(true);
            } else {
              sepeteEkleHandler();
            }
          }}
          vazgecHandler={sepeteEkleVazgecHandler}
          productQuantity={productQuantity}
          itemCreateLoading={itemCreateLoading}
        ></SepetItemCreator>

        {showQuestions && product.questions?.length > 0 && (
          <AskQuestionModal
            questions={questions || []}
            setQuestions={setQuestions}
            showQuestions={showQuestions}
            setShowQuestions={setShowQuestions}
            sepeteEkleHandler={sepeteEkleHandler}
          ></AskQuestionModal>
        )}

        <NumberPad
          numberPadNumber={numberPadNumber}
          setNumberPadNumber={setNumberPadNumber}
          showNumberPad={showNumberPad}
          setShowNumberPad={setShowNumberPad}
          setNumberPadSelectionHandler={(num) => {
            setNumberPadNumberSelectionHandler(num);
          }}
          errorMessage={"Ürün numarasi 1000'den büyük olamaz!"}
          errorLimit={1000}
          headerMessage={"Ürün Numarası:"}
        ></NumberPad>
      </div>
    </div>
  );
}
